// File: src/EnglishTool/adverbsPool.js

/**
 * Return an array of adverbs for the given grade.
 * Each grade has 10 items. Adjust/expand these as desired!
 */
export function getAdverbsPool(grade) {
    switch (grade) {
      case 1:
        return [
          "slowly", "quickly", "loudly", "softly", "well",
          "fast", "today", "tomorrow", "here", "now"
        ];
      case 2:
        return [
          "quietly", "brightly", "carefully", "easily", "happily",
          "sadly", "yesterday", "outside", "nicely", "soon"
        ];
      case 3:
        return [
          "suddenly", "frequently", "politely", "rapidly", "rarely",
          "barely", "calmly", "occasionally", "honestly", "wildly"
        ];
      case 4:
        return [
          "constantly", "simply", "briskly", "promptly", "thoroughly",
          "fiercely", "eagerly", "forever", "strictly", "completely"
        ];
      case 5:
        return [
          "deliberately", "unusually", "normally", "gracefully", "mysteriously",
          "purposefully", "universally", "carelessly", "unfortunately", "effectively"
        ];
      case 6:
        return [
          "incredibly", "intensely", "repeatedly", "fortunately", "commonly",
          "possibly", "primarily", "subtly", "precisely", "instantly"
        ];
      case 7:
        return [
          "unquestionably", "undoubtedly", "significantly", "accurately", "ethically",
          "notably", "readily", "perpetually", "seemingly", "eventually"
        ];
      case 8:
        return [
          "remarkably", "routinely", "theoretically", "simultaneously", "vividly",
          "tremendously", "electronically", "independently", "grudgingly", "distinctly"
        ];
      case 9:
        return [
          "fundamentally", "immensely", "figuratively", "paradoxically", "ostensibly",
          "consequently", "tentatively", "delicately", "ruthlessly", "productively"
        ];
      case 10:
        return [
          "phenomenally", "substantially", "inevitably", "categorically", "meticulously",
          "randomly", "conclusively", "assuredly", "thematically", "instantaneously"
        ];
      case 11:
        return [
          "unequivocally", "irrevocably", "passionately", "profoundly", "cautiously",
          "extensively", "hypothetically", "methodically", "systematically", "sporadically"
        ];
      case 12:
        return [
          "indubitably", "infinitesimally", "circumstantially", "dramatically", "notoriously",
          "insightfully", "transcendentally", "precariously", "insatiably", "imperceptibly"
        ];
      default:
        // Fallback if the grade is out of range:
        return [
          "quickly", "slowly", "loudly", "softly", "honestly",
          "rarely", "thoroughly", "constantly", "suddenly", "soon"
        ];
    }
  }
  